import { render, staticRenderFns } from "./Add_packaging.vue?vue&type=template&id=37ee8938&"
import script from "./Add_packaging.vue?vue&type=script&lang=js&"
export * from "./Add_packaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports